module.exports = __webpack_public_path__ + "img/workshops.d7632c53.svg";